require('angular').module('wowApp.common')
    .service('CurationService', [require('./bazaarvoicecuration-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/bazaarvoicecuration/index.js
 **/